import React from 'react'

import { applyStyle } from '../helpers/styles'

export const useCursorStyle = props => {
  const { cursor } = props

  return React.useMemo(() => {
    return `
      ${applyStyle('cursor', cursor)}
    `
  }, [cursor])
}
